import React from 'react';
import { Body, Box, Icon } from '@hover/blueprint';
import { IconProp, iPlus } from '@hover/icons';
import { motion } from '@hover/blueprint/foundation';

interface Props {
  isCurrent: boolean;
  itemId: number;
  setCurrentTab: (tabId: number) => void;
  currentTab: number;
  isLast: boolean;
  icon?: IconProp;
  svgIcon?: React.ReactNode;
  title: string;
  titleColor: 'brandNavy.500' | 'red.500';
}

const SwitcherButton: React.FC<Props> = ({
  isCurrent,
  itemId,
  setCurrentTab,
  currentTab,
  isLast,
  icon,
  svgIcon,
  title,
  titleColor,
}) => (
  <Box
    as="button"
    aria-expanded={isCurrent}
    aria-controls={`panel-${itemId}`}
    id={`tab-${itemId}`}
    cursor="pointer"
    w="100%"
    flexDir="row"
    alignItems="center"
    justifyContent="space-between"
    mb={isCurrent ? 400 : 0}
    onClick={() => {
      if (currentTab === itemId) {
        if (isLast) {
          return setCurrentTab(0);
        }
        return setCurrentTab(currentTab + 1);
      }
      return setCurrentTab(itemId);
    }}
    px={{ base: 500, desktop: 400 }}
  >
    <Box flexDir="row" alignItems="center">
      {icon && (
        <Icon icon={icon} size="large" color={titleColor} m={0} mr={400} />
      )}
      {svgIcon && <Box mr={400}>{svgIcon}</Box>}
      {!icon && !svgIcon && (
        <Box
          mr={400}
          w={300}
          h={300}
          borderRadius="50%"
          bg={isCurrent ? 'neutral.0' : 'red.100'}
          alignItems="center"
          justifyContent="center"
        >
          <Body size={500} isBold lineHeight="20px" color="danger.500">
            {itemId + 1}
          </Body>
        </Box>
      )}
      <Body
        letterSpacing="2px"
        size={500}
        isBold
        lineHeight="20px"
        color={titleColor}
        as="h3"
      >
        {title.toUpperCase()}
      </Body>
    </Box>
    <Icon
      m={0}
      icon={iPlus}
      size="default"
      strokeWidth="2px"
      transform={`rotateZ(${!isCurrent ? 0 : '45deg'})`}
      transition={`all ${motion.easings[250]}`}
    />
  </Box>
);

SwitcherButton.defaultProps = {
  icon: undefined,
  svgIcon: undefined,
};

export default SwitcherButton;
